import { cn } from "@newxsystems/shared";
import { GroundAction } from "../GroundAction/GroundAction";
import { GroundMedia } from "../GroundMedia/GroundMedia";
import { GroundRichText } from "../GroundRichText/GroundRichText";
import type { ICallToActionStackedProps } from "./CallToActionStacked.props";

const widths = { small: "w-1/2", medium: "w-3/4", large: "w-full" } as const;

export const CallToActionStacked = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionStackedProps) => {
  const centered = alignment === "center";
  return (
    <div className={cn("flex flex-col gap-5", centered && "items-center text-center")}>
      {eyebrow ? (
        <p className="border-b border-mineral-gray/40 pb-2 font-ground-mono text-xs">{eyebrow}</p>
      ) : null}
      {image ? (
        <GroundMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className={cn("my-3", widths[imageWidth || "medium"])}
          media={image.image}
          sizes="(min-width: 1024px) 70vw, 100vw"
        />
      ) : null}
      {heading ? (
        <h2 className="max-w-[16ch] font-ground-display text-[clamp(1.875rem,9vw,3.75rem)] font-bold leading-[0.98] tracking-[-0.025em] text-balance [overflow-wrap:normal] [word-break:normal] hyphens-none">
          {heading}
        </h2>
      ) : null}
      {description ? (
        <GroundRichText className="max-w-[65ch] text-mineral-gray" content={description} />
      ) : null}
      {buttons?.length ? (
        <div className={cn("flex flex-wrap gap-3 pt-3", centered && "justify-center")}>
          {buttons.map((button, index) => (
            <GroundAction
              action={button}
              className="border-mineral-gray text-mineral-gray"
              key={`${button.href}-${index}`}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

CallToActionStacked.displayName = "Content::CallToActionStacked";
